module.exports = __webpack_public_path__ + "static/img/8.c1152f3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/1/zh/8.png
// module id = uO5n
// module chunks = 0